import type { Language } from '../i18n/messages';
import { createDefaultData, parseAppData, readJson, type AppData } from './app-data';

export const STORAGE_KEY = 'plan-to-eating';
export const UNREADABLE_KEY = 'plan-to-eating.unreadable';

/**
 * DE: Daten laden; Unlesbares wird unter einem Ersatzschlüssel aufbewahrt, nie stillschweigend gelöscht.
 * EN: Load the data; unreadable text is kept under a spare key, never silently dropped.
 */
export function loadAppData(storage: Storage, fallbackLanguage: Language): AppData {
  const raw = storage.getItem(STORAGE_KEY);
  if (raw === null) return createDefaultData(fallbackLanguage);
  const data = parseAppData(readJson(raw));
  if (data) return data;
  storage.setItem(UNREADABLE_KEY, raw);
  return createDefaultData(fallbackLanguage);
}

/**
 * DE: Daten als JSON speichern.
 * EN: Save the data as JSON.
 */
/**
 * DE: Daten für einen Neustart beiseitelegen; die Kopie bleibt unter dem Ersatzschlüssel.
 * EN: Set the data aside for a fresh start; the copy stays under the spare key.
 */
export function setAsideData(storage: Storage): void {
  const raw = storage.getItem(STORAGE_KEY);
  if (raw === null) return;
  storage.setItem(UNREADABLE_KEY, raw);
  storage.removeItem(STORAGE_KEY);
}

export function saveAppData(storage: Storage, data: AppData): void {
  storage.setItem(STORAGE_KEY, JSON.stringify(data));
}
